import { LimitInVod } from '../utils/Decorator';
/**
 * 回放API
 *
 * @export
 * @class VodApi
 */
export default class VodApi {
  constructor(vod) {
    this._vod = vod;
  }

  /**
   * 设置当前回放时间
   *
   * @param {*} t
   * @memberof DocModuler
   */
  @LimitInVod()
  vodTime(t) {
    return this._vod.time(t);
  }

  /**
   * 设置回放数据
   *
   * @param {*} data
   * @memberof DocModuler
   */
  @LimitInVod()
  vodSetData(data) {
    this._vod.data = data;
  }

  /**
   * 设置完数据后，获取所有容器的接口
   *
   * @returns
   * @memberof DocModuler
   */
  @LimitInVod()
  vodAllCids() {
    return this._vod.allCidInfos();
  }

  /**
   * 获取所有激活列表
   *
   * @returns
   * @memberof DocModuler
   */
  @LimitInVod()
  vodAllActivatedCids() {
    return this._vod.allActivatedCids();
  }

  /**
   * 获取所有观看开关
   *
   * @returns
   * @memberof DocModuler
   */
  @LimitInVod()
  vodAllWatchStatus() {
    return this._vod.allWatchStatus();
  }

  /**
   * 是否使用降级策略
   *
   * @memberof VodApi
   */
  @LimitInVod()
  vodIsUseCompat() {
    return this._vod.useCompat;
  }
}
